import { defineStore } from "pinia";
import { ref, computed } from "vue"; // Import von ref und computed aus Vue

export const useBaseStore = defineStore("baseStore", () => {
  // Initialisiere windowWidth mit einem Standardwert, falls window nicht verfügbar ist
  const windowWidth = ref(
    typeof window !== "undefined" ? window.innerWidth : 0
  );

  const isMobile = computed(() => windowWidth.value < 768);
  const isIpadAndBelow = computed(() => windowWidth.value < 1450);
  const showMenueRechts = computed(() => windowWidth.value >= 1450);
  const isDesktop = computed(() => windowWidth.value >= 770);
  const screenSize = computed(() => windowWidth.value);

  // Wichtig: Setup nur ausführen, wenn wir im Browser sind
  if (typeof window !== "undefined") {
    // Sofort hinzufügen (nicht in einem Hook wie onMounted)
    window.addEventListener("resize", () => {
      windowWidth.value = window.innerWidth;
    });
  }

  function getTimeAgo(datevor) {
    const now = new Date();
    const date = new Date(datevor);
    const diff = now - date; // difference in milliseconds
  
    const diffMinutes = Math.floor(diff / 60000);
  
    if (diffMinutes < 60) {
      return `vor ${diffMinutes} Minuten`;
    } else if (diffMinutes < 1440) {
      const diffHours = Math.floor(diffMinutes / 60);
      if (diffHours == 1) {
        return `vor einer Stunde`;
      } else {
        return `vor ${diffHours} Stunden`;
      }
    } else {
      const diffDays = Math.floor(diffMinutes / 1440);
      if (diffDays == 1) {  
        return `vor einem Tag`;
      } else {
        return `vor ${diffDays} Tagen`;
      }
    }
  }// Die Funktionen, die du verwenden möchtest


  function formatGermanDate(dateString) {
    const date = new Date(dateString);
    const options = {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      // second: '2-digit', // Falls die Sekunden benötigt werden
    };
    return date.toLocaleDateString('de-DE', options);
  }

  // Gib die reaktiven Daten und Methoden zurück
  return {
    windowWidth,
    getTimeAgo,
    isMobile,
    isIpadAndBelow,
    isDesktop,
    screenSize,
    showMenueRechts,
    formatGermanDate,
  };
});
